import { render } from "./AddressCreateComponent.vue?vue&type=template&id=1cd84d2c"
import script from "./AddressCreateComponent.vue?vue&type=script&lang=js"
export * from "./AddressCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/account/address/AddressCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cd84d2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cd84d2c', __exports__)) {
    api.reload('1cd84d2c', __exports__)
  }
  
  module.hot.accept("./AddressCreateComponent.vue?vue&type=template&id=1cd84d2c", () => {
    api.rerender('1cd84d2c', render)
  })

}


export default __exports__